import { updateTask } from "@/models/tasks.model";
import { AppContext } from "@/services/AppContext/appContext";
import { EditedTask } from "@/types";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils";
import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useCallback,
  useContext,
} from "react";

const useHandleSave = (
  editedTask: EditedTask | null,
  cache: "UserTasks" | "PrecacheTasks",
  saveAllowed: MutableRefObject<boolean>,
  editedTaskRef: MutableRefObject<EditedTask | null>,
  setIsEditing: Dispatch<SetStateAction<boolean>>,
  setSelectedEditableTask: Dispatch<SetStateAction<EditedTask | null>>
) => {
  const { initialGetUserTasks, getPrecacheTasks } = useContext(AppContext);

  const handleSave = useCallback(async () => {
    if (!editedTask) return;
    setSelectedEditableTask(editedTask);
    setIsEditing(false);

    const res = await updateTask({ task: editedTask });
    if (res.rStatus === "success") {
      // Visually update the task, in the event subsequent call is too quick
      console.log("Task updated successfully");
      genericSuccessToast("Task updated successfully");
      // await initialGetUserTasks({ force: true });
      // based on cache type, update the cache
      if (cache === "UserTasks") {
        await initialGetUserTasks({ force: true });
      } else {
        await getPrecacheTasks(false, true);
      }
    } else {
      genericFailureToast("Failed to update task");
      setSelectedEditableTask(null);
    }

    saveAllowed.current = false;
    editedTaskRef.current = null;
    setIsEditing(false);
  }, [
    editedTask,
    setSelectedEditableTask,
    setIsEditing,
    saveAllowed,
    editedTaskRef,
    cache,
    initialGetUserTasks,
    getPrecacheTasks,
  ]);

  return { handleSave };
};

export default useHandleSave;
